import React from 'react';
import styled from 'styled-components';
import Cookies from 'js-cookie';
import { Button } from 'shared/components';

import { ModalContainer, ModalExitIcon } from 'shared/modals/v2-container';

const CriticalAnnouncementModal = ({ containerProps, onClose, config }) => {
  const { name, content } = config || {};

  const handleDismiss = () => {
    if (name) {
      // Set cookie to dismiss this announcement permanently
      // Cookie expires in 30 days
      Cookies.set(`dtch-announcement-dismissed-${name}`, 'true', { expires: 30 });
    }
    onClose();
  };

  if (!config || !name || !content) {
    return null;
  }

  return (
    <StyledModalContainer {...containerProps} width='700px' maxWidth='90vw' maxHeight='90vh'>
      <ModalExitIcon onClick={handleDismiss} />
      <ContentWrapper>
        <AnnouncementContent dangerouslySetInnerHTML={{ __html: content }} />
        <DismissButton onClick={handleDismiss}>Continue to Checkout</DismissButton>
      </ContentWrapper>
    </StyledModalContainer>
  );
};

const StyledModalContainer = styled(ModalContainer)`
  display: flex;
  flex-direction: column;

  /* Override default height behavior for better control */
  // height: 80vh;
  max-height: 80vh;

  /* Ensure content fits within viewport */
  box-sizing: border-box;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;

  /* Reserve space for button at bottom */
  max-height: calc(80vh - 100px); /* Account for modal padding, exit icon, and button space */
`;

const AnnouncementContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px 0 10px 0;
  min-height: 0; /* Important for flex shrinking */
  max-height: 100%; /* Ensure it doesn't exceed container */

  // Style the HTML content appropriately
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0 0 16px 0;
    color: black;
  }

  p {
    margin: 0 0 16px 0;
    line-height: 1.5;
    color: ${({ theme }) => theme?.colors?.black?.[70]};
    text-align: left;
  }

  a {
    color: ${({ theme }) => theme?.colors?.primaryBlue};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  strong,
  b {
    font-weight: 600;
    color: ${({ theme }) => theme?.colors?.black?.[85]};
  }

  ul,
  ol {
    margin: 0;
  }

  li {
    margin-bottom: 8px;
    color: ${({ theme }) => theme?.colors?.black?.[70]};
  }
`;

const DismissButton = styled(Button)`
  margin: 20px auto 0 auto;
  flex-shrink: 0; /* Prevents button from shrinking */
  align-self: center;
  width: auto;
`;

export default CriticalAnnouncementModal;
